import React, { useState, useEffect } from "react";
import {
  Accordion,
  ButtonGroup,
  Button,
  Card,
  Modal,
  Tabs,
  Tab,
} from "react-bootstrap";
import { TABS } from "../../constants/app-constant";
import { formatArticleIdentifier, groupBy } from "../../utility/common-methods";
import {
  NoFeedIcon,
  ModalCloseIcon,
  PrintIcon,
  GlobeIcon,
} from "../Icons/icons.component";
import Loader from "../Shared/Loader";
import FeedItem from "./FeedItem";
import ShareArticle from "../Shared/ShareArticle";
import Sticky from "react-sticky-el";

export const AllFeedsModal = function ({
  show,
  selectedTabKey,
  selectedTopic,
  tabFeeds,
  onCancel,
  printData,
  onlineData,
  loaderState,
  handleTopicClick,
  handleTabClick,
  clientId,
  pressReleaseData,
  compare,
  TotalPrintData,
  clientName,
}) {
  const [tabKey, setTabKey] = useState(selectedTabKey);
  const [feedsToShare, setFeedsToshare] = useState([]);
  const [activeKey, setActiveKey] = useState(1);
  const [allArticleIds, setAllArticleIds] = useState([]);
  const [selectAllList, setSelectAllList] = useState([]);
  const pressRelease = "Press Release";

  useEffect(() => {
    setFeedsToshare([]);
    setSelectAllList({});
  }, [loaderState]);

  useEffect(() => {
    if (tabFeeds && Object.keys(tabFeeds[tabKey]).length > 0) {
      Object.keys(selectAllList).forEach((e) => {
        const data = groupBy(tabFeeds[tabKey], "entity_name");
        const sFeeds = data[e];
        const sData = feedsToShare.filter((feed) => feed.entity_name == e);
        if (sFeeds && sData && sFeeds.length !== sData.length) {
          setSelectAllList(Object.assign(selectAllList, { [e]: false }));
        }
      });
    }
  }, [feedsToShare]);

  useEffect(() => {
    setTabKey(selectedTabKey);
  }, [selectedTabKey]);

  useEffect(() => {
    try {
      let tempData = printData;
      let article_type = "Print";
      if (onlineData && Object.keys(onlineData).length) {
        tempData = onlineData;
        article_type = "Online";
      }
      if (tempData) {
        const currentTabData = tempData[tabKey];
        let topicWiseData = groupBy(currentTabData, "entity_name");
        topicWiseData = Object.values(topicWiseData).flat();
        setAllArticleIds(
          topicWiseData.map((elm) =>
            formatArticleIdentifier({ ...elm, article_type })
          )
        );
      }
    } catch (e) {
      setAllArticleIds([]);
    }
  }, [printData, onlineData, tabKey]);

  const handleSelectedFeeds = (
    selected,
    {
      article_id,
      edition,
      entity_id,
      entity_name,
      entity_type,
      headline,
      language,
      link,
      photo,
      page_nos,
      publication,
      publication_type,
      publish_date,
      source,
      summary,
      source_name,
      images,
      imagebaseurl,
      article_type,
    }
  ) => {
    if (selected) {
      setFeedsToshare([
        ...feedsToShare,
        {
          article_id,
          edition,
          entity_id,
          entity_name,
          entity_type,
          headline,
          language,
          link: link,
          photo: photo,
          page_nos: page_nos,
          publication,
          publication_type,
          publish_date,
          source,
          summary,
          source_name,
          images,
          imagebaseurl,
          article_type,
        },
      ]);
    } else {
      setFeedsToshare(feedsToShare.filter((n) => n.article_id != article_id));
      setSelectAllList(
        Object.assign(selectAllList, {
          [entity_name]: false,
        })
      );
    }
  };

  const handleSelectAll = (checked, key) => {
    const data = groupBy(tabFeeds[tabKey], "entity_name");
    const sFeeds = data[key];
    setSelectAllList(
      Object.assign(selectAllList, {
        [key]: checked,
      })
    );
    if (checked) {
      setFeedsToshare(removeDuplicateFeeds([...feedsToShare, ...sFeeds]));
    } else {
      setFeedsToshare([...feedsToShare.filter((f) => f.entity_name != key)]);
    }
  };

  const removeDuplicateFeeds = (data = []) => {
    data = data.filter(
      (d, index, self) =>
        index === self.findIndex((t) => t.article_id === d.article_id)
    );

    return data;
  };

  const checkIfSelected = (key) => {
    return feedsToShare.filter((f) => f.article_id == key).length > 0
      ? true
      : false;
  };

  const renderPrintTabData = () => {
    if (Object.keys(printData).length > 0) {
      tabFeeds = printData;
      return TABS.map((item, index) => {
        return (
          <Tab
            eventKey={item}
            title={`${
              item === "Competitor" && clientName ? "Subsidiaries" : item
            }(${TotalPrintData[item] ? TotalPrintData[item].length : "0"})`}
          >
            {loaderState ? (
              <Loader />
            ) : (
              <>
                <div className="allFeedsAccordionWrap">
                  {tabFeeds[tabKey] ? (
                    <Accordion
                      defaultActiveKey={1}
                      onSelect={(e) => {
                        setActiveKey(e ? e : "");
                      }}
                    >
                      {renderAccordian()}
                    </Accordion>
                  ) : (
                    <div className="noFilterDataWrap no-feeds">
                      <NoFeedIcon size="sm" />
                      <h6>No Feeds Found</h6>
                    </div>
                  )}
                </div>
              </>
            )}
          </Tab>
        );
      });
    }
  };

  const renderOnlineTabData = () => {
    if (Object.keys(onlineData).length > 0) {
      tabFeeds = onlineData;
      return TABS.map((item, index) => {
        return (
          <Tab
            key={index}
            eventKey={
              item === "Competitor" && clientName ? "Subsidiaries" : item
            }
            title={`${item}(${tabFeeds[item] ? tabFeeds[item].length : "0"})`}
          >
            {loaderState ? (
              <Loader />
            ) : (
              <>
                <div className="allFeedsAccordionWrap">
                  {tabFeeds[tabKey] ? (
                    <Accordion
                      defaultActiveKey={1}
                      onSelect={(e) => setActiveKey(e ? e : "")}
                    >
                      {renderAccordian()}
                    </Accordion>
                  ) : (
                    <div className="noFilterDataWrap no-feeds">
                      <NoFeedIcon size="sm" />
                      <h6>No Feeds Found</h6>
                    </div>
                  )}
                </div>
              </>
            )}
          </Tab>
        );
      });
    }
  };

  const renderFeeds = (data) => {
    return (
      <>
        {data.map((item, index) => (
          <FeedItem
            tabKey={tabKey}
            key={index}
            {...item}
            isModal={true}
            topicType={selectedTopic}
            onFeedSelect={handleSelectedFeeds}
            articleIdList={allArticleIds}
            checked={checkIfSelected(item.article_id)}
            abbreviation={item.abbreviation}
          />
        ))}
      </>
    );
  };

  const renderAccordian = () => {
    const data = groupBy(tabFeeds[tabKey], "entity_name");
    return Object.keys(data).map((key, index) => {
      const allCountData = groupBy(TotalPrintData[tabKey], "entity_name");
      const feedCount =
        selectedTopic === "print" ? allCountData[key].length : data[key].length;
      const isAccordianSelected = selectAllList && selectAllList[key];
      return (
        <Card
          className={
            activeKey == +(index + 1)
              ? "customAccordionRow feedAccordion active"
              : "customAccordionRow feedAccordion"
          }
        >
          <Sticky
            scrollElement=".allFeedsAccordionWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <Card.Header>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  checked={isAccordianSelected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    handleSelectAll(!isAccordianSelected, key);
                  }}
                />
                <span className="checkmark"></span>
              </label>
              <Accordion.Toggle as={Button} variant="link" eventKey={index + 1}>
                {data[key][0].entity_display_name} {`(${feedCount})`}
              </Accordion.Toggle>
            </Card.Header>
          </Sticky>
          <Accordion.Collapse eventKey={index + 1}>
            <Card.Body>{renderFeeds(data[key])}</Card.Body>
          </Accordion.Collapse>
        </Card>
      );
    });
  };

  const renderPressReleaseAccordian = () => {
    if (pressReleaseData && pressReleaseData.length) {
      const data = groupBy(pressReleaseData.sort(compare), "entity_name");
      return Object.keys(data).map((key, index) => {
        return (
          <Card
            key={index}
            className={
              activeKey == +(index + 1)
                ? "customAccordionRow feedAccordion active"
                : "customAccordionRow feedAccordion"
            }
          >
            <Sticky
              scrollElement=".allFeedsAccordionWrap"
              boundaryElement=".customAccordionRow"
              style={{ position: "relative" }}
              hideOnBoundaryHit={false}
            >
              <Card.Header>
                <label className="inputWrap">
                  <input
                    type="checkbox"
                    checked={selectAllList}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleSelectAll(e.target.checked, key)}
                  />
                  <span className="checkmark"></span>
                </label>
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  eventKey={index + 1}
                >
                  {data[key][0].entity_display_name} {`(${data[key].length})`}
                </Accordion.Toggle>
              </Card.Header>
            </Sticky>
            <Accordion.Collapse eventKey={index + 1}>
              <Card.Body>{renderFeeds(data[key])}</Card.Body>
            </Accordion.Collapse>
          </Card>
        );
      });
    }
  };

  const renderPressReleaseTab = () => {
    return (
      <Tab
        eventKey={pressRelease}
        title={`${pressRelease}(${
          pressReleaseData && pressReleaseData.length
            ? pressReleaseData.length
            : 0
        })`}
      >
        {loaderState ? (
          <Loader />
        ) : (
          <>
            <div className="allFeedsAccordionWrap">
              {pressReleaseData.length ? (
                <Accordion
                  onSelect={(e) => setActiveKey(e ? e : "")}
                  defaultActiveKey={1}
                >
                  {renderPressReleaseAccordian()}
                </Accordion>
              ) : (
                <div className="noFilterDataWrap no-feeds">
                  <NoFeedIcon size="sm" />
                  <h6>No Feeds Found</h6>
                </div>
              )}
            </div>
          </>
        )}
      </Tab>
    );
  };

  const tabClick = (tab) => {
    setTabKey(tab);
    handleTabClick(tab);
  };

  return (
    <Modal
      dialogClassName="customModal"
      className="allFeedsModal"
      show={show}
      onHide={() => onCancel(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <span className="btnClose" onClick={() => onCancel(false)}>
          <ModalCloseIcon />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="modelHeader">
          <ButtonGroup
            className="smallToggleBtnGroup"
            onClick={(e) => handleTopicClick(e.target.value)}
          >
            <Button
              className={
                selectedTopic === "print" ? "tagOrange active" : "tagOrange"
              }
              value={"print"}
            >
              <PrintIcon /> Print
            </Button>
            <Button
              className={
                selectedTopic === "online" ? "tagGreen active" : "tagGreen"
              }
              value={"online"}
            >
              <GlobeIcon /> Online
            </Button>
          </ButtonGroup>
          <ShareArticle
            client_id={clientId}
            article={feedsToShare}
            onShareSuccess={() => {
              setFeedsToshare([]);
              setSelectAllList([]);
            }}
          />
        </div>
        {
          <>
            {loaderState ? (
              <Loader />
            ) : (
              <Tabs
                activeKey={tabKey}
                transition={false}
                onSelect={(tab) => tabClick(tab)}
              >
                {selectedTopic == "print"
                  ? renderPrintTabData()
                  : renderOnlineTabData()}
                {renderPressReleaseTab()}
              </Tabs>
            )}
          </>
        }
      </Modal.Body>
    </Modal>
  );
};

AllFeedsModal.defaultProps = {
  show: false,
  onCancel: () => {},
  cancelButtonText: "Cancel",
};
